import { formatAmount } from "@origin-digital/formatters";

import { getNumber } from "@/utils";

export function transformCurrency(value: string) {
  if (value) {
    const number = parseFloat(getNumber(value));
    if (typeof number === "number" && !isNaN(number)) {
      return formatAmount(number);
    }
  }

  return value;
}
